import { Product } from "../types";

export const calculateSum = (
  selectedProducts: Product[],
  type: 0 | 1 | 12 = 0
) => {
  let sum = 0;
  selectedProducts.forEach((product) => {
    if (product.product_prices.length === 0) return;
    if (product.product_prices[0].price.interval !== type) return;

    sum += product.product_prices[0].price.price;
  });
  return sum;
};
